import { req,importFile } from './axiosFun';
/**
 * 首页统计
 **/
// 概况
export const qryStatistics = (params) => { return req("post", "/yishantong-ui/statistics/qryStatistics", params) };

//数据库
export const qryGraph = (params) => { return req("post", "/yishantong-ui/statistics/qryGraph", params) };

// 数据图导出
export const graphExcel = (params) => { return importFile("post", "/yishantong-ui/statistics/graphExcel", params) };




// WEBPACK FOOTER //
// ./src/api/statisticsApi.js